import React from 'react';
import { withStyles } from '@material-ui/core';
import CustomToolTip from '../ToolTip/ToolTip';
import { hasTransfer } from '../../../utilities/shiftFunctions';
import { genBodyTooltipShiftTemplate, genBodyTooltipPaycode, genBodyTooltipShiftWfc } from './shiftDetails';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ShiftCardButtonActionMenu from "./shiftCardButtonActionMenu";
import { faCommentAltDots } from '@fortawesome/pro-regular-svg-icons';
import { faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';
import { faRandom } from '@fortawesome/pro-regular-svg-icons';
import { exists } from '../../../../common/utilities/utilitiesFunctions';
import clsx from 'clsx';
import { shiftCardstyles } from "./style";
import './ShiftCard.scss';

const styles = theme => shiftCardstyles(theme);

const ShiftCard = ({
    t,
    withTooltip,
    tooltipPlacement,
    shift,
    paycode,
    classes,
    handleClick = () => { },
    origine = 'dimensions',
    isOriginal = true,
    isTemplate = false,
    changePointer = true,
    disableMenuButton = true,
    onSetJobTransfer = () => { },
    onSetSkillAndCertificationProfiles = () => { },
    isAsyncTaskProcessing = false 
}) => {
    let transfert = '';
    let swap = '';
    let notes = '';
    let titleText = '';
    let content = '';

    const isShift = exists(shift);
    const isPaycode = exists(paycode);
    

    if (isShift) {
        transfert = hasTransfer(shift, origine) ? <FontAwesomeIcon style={{ marginLeft: '10px', marginRight: '18px' }} icon={faExchangeAlt} /> : <></>

        if (shift.commentNotes && shift.commentNotes.length > 0) {
            notes = <FontAwesomeIcon style={{ color: '#0a54a2' }} icon={faCommentAltDots} />;
        }

        if (shift.swapped) {
            swap = <FontAwesomeIcon style={{ color: '#0a54a2' }} icon={faRandom} />;
        }
    }

    if (origine === 'dimensions') {
        titleText = isShift ? genBodyTooltipShiftTemplate(shift, t, isTemplate) : genBodyTooltipPaycode(paycode);
        content = isShift ?
            (
                (shift.label !== null && shift.label !== '')
                    ? (
                        <>
                            <span>{shift.label}</span>
                            {transfert}
                        </>
                    )
                    : <><span>{shift.startDateTime.substring(11, 16) + ' - ' + shift.endDateTime.substring(11, 16)}</span> {transfert}</>
            )
            :
            isPaycode ? paycode.name : '';
    } else {
        titleText = typeof shift !== 'undefined' ? genBodyTooltipShiftWfc(shift) : paycode.PayCodeName;
        content = <React.Fragment>
            {
                isShift ? (typeof shift.ShiftLabel !== 'undefined' && shift.ShiftLabel !== '')
                    ? shift.ShiftLabel
                    : shift.shiftSegments[0].StartTime + ' - ' + shift.shiftSegments[shift.shiftSegments.length - 1].EndTime : ''
            }
            {isPaycode ? paycode.PayCodeName : ''}
        </React.Fragment>;
    }
    let div = (
        <span>
            <div 
                key={"ShiftCard" + Math.floor(Math.random() * 100)}
                onClick={(e) => handleClick(e, isShift ? shift : paycode)}
                className={clsx(classes.tagContainer, changePointer ? classes.tagContainerPointer : '')}
            >
                <div className={isShift ? (shift.open ? classes.divTagContainerOpenshift : classes.divTagContainerBorder) : classes.divTagContainerPaycode}></div>
                <div className={clsx('divTagContainer', classes.divTagContainer,
                    isShift
                        ? isOriginal
                            ? ''
                            : (shift.open ? classes.tagContainerOpenshiftDouble : classes.tagContainerShiftDouble)
                        : ''
                )}>
                    {content}
                    {(isShift && !disableMenuButton) &&
                        <ShiftCardButtonActionMenu
                            isAsyncTaskProcessing={isAsyncTaskProcessing}
                            onSetJobTransfer={onSetJobTransfer}
                            onSetSkillAndCertificationProfiles={onSetSkillAndCertificationProfiles}
                        />}
                </div>
                {swap ? <div className={classes.divIcone}>{swap}</div> : ''}
                {notes ? <div className={classes.divIcone}>{notes}</div> : ''}
            </div >
        </span>
    );

    if (withTooltip) {
        return (
            <CustomToolTip
                placement={tooltipPlacement}
                enterDelay={200}
                leaveDelay={0}
                titletext={titleText}
                jsx={div}
            />
        )
    } else {
        return (typeof shift !== 'undefined'
            ? div
            : origine === 'dimensions' ? paycode.name : paycode.PayCodeName);
    }
}

export default React.memo(withStyles(styles)(ShiftCard))